import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.188 12a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334m4-11.333h-8a.667.667 0 0 0-.667.666v6a2 2 0 0 0 2 2h.667v1.58a2.667 2.667 0 1 0 4 0v-1.58h.666a2 2 0 0 0 2-2v-6a.666.666 0 0 0-.666-.666M8.188 14a1.334 1.334 0 0 1-.887-2.32.67.67 0 0 0 .22-.493V9.333h1.333v1.854a.67.67 0 0 0 .22.493A1.333 1.333 0 0 1 8.188 14m3.333-6.667a.667.667 0 0 1-.667.667H5.521a.667.667 0 0 1-.667-.667v-.666h6.667zm0-2H4.854V2h6.667z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })